const DEFAULT_GALLERY_MANIFEST = "/content/gallery.json";
const DEFAULT_AZURE_GALLERY_BLOB_PATH = "gallery.json";

const trimSlashes = (value = "") => value.replace(/^\/+|\/+$/g, "");

const isAbsoluteUrl = (value = "") => /^https?:\/\//i.test(value);

const fetchJson = async (url) => {
  const response = await fetch(url, { cache: "no-store" });

  if (!response.ok) {
    throw new Error(`Request failed with ${response.status}`);
  }

  const contentType = response.headers.get("content-type") || "";

  if (!contentType.includes("application/json")) {
    throw new Error("Response was not JSON");
  }

  return response.json();
};

export const getGalleryManifestUrl = () => {
  const configuredUrl = process.env.REACT_APP_GALLERY_MANIFEST;

  if (configuredUrl) {
    return configuredUrl;
  }

  const baseUrl = trimSlashes(process.env.REACT_APP_AZURE_BLOB_BASE_URL || "");

  if (!baseUrl) {
    return DEFAULT_GALLERY_MANIFEST;
  }

  const manifestPath = trimSlashes(process.env.REACT_APP_AZURE_GALLERY_BLOB_PATH || DEFAULT_AZURE_GALLERY_BLOB_PATH);
  return `${baseUrl}/${manifestPath}`;
};

export const resolveAssetUrl = (path) => {
  if (!path) {
    return "";
  }

  if (isAbsoluteUrl(path) || path.startsWith("/")) {
    return path;
  }

  const baseUrl = trimSlashes(process.env.REACT_APP_AZURE_BLOB_BASE_URL || "");

  if (!baseUrl) {
    return path;
  }

  return `${baseUrl}/${trimSlashes(path)}`;
};

const normalizeImage = (image) => {
  if (typeof image === "string") {
    return {
      src: resolveAssetUrl(image),
      alt: "",
      label: "",
    };
  }

  return {
    ...image,
    src: resolveAssetUrl(image.src),
  };
};

const normalizeProject = (project) => {
  const before = project.before ? normalizeImage(project.before) : null;
  const after = project.after ? normalizeImage(project.after) : null;
  const images = (project.images || []).map(normalizeImage);
  const cover = project.cover ? normalizeImage(project.cover) : after || before || images[0] || null;

  return {
    ...project,
    before,
    after,
    images,
    cover,
    hasTransformation: Boolean(before && after),
  };
};

export const loadGallery = async () => {
  let manifest;

  try {
    manifest = await fetchJson("/api/gallery");
  } catch {
    const manifestUrl = getGalleryManifestUrl();

    try {
      manifest = await fetchJson(manifestUrl);
    } catch {
      manifest = await fetchJson(DEFAULT_GALLERY_MANIFEST);
    }
  }

  return {
    projects: (manifest.projects || []).map(normalizeProject),
    servicesGallery: (manifest.servicesGallery || []).map(normalizeImage),
  };
};
